/**
 * Mobile network identity helpers for the connection history (docs/architecture/14).
 *
 * PLMN = MCC-MNC as the modem reports it ("226-01"). The operator names below are the Romanian networks the fleet
 * roams on; any other code is shown as-is so an unexpected network is never mislabelled.
 */
const OPERATORS: Readonly<Record<string, string>> = {
  '226-01': 'Vodafone RO',
  '226-10': 'Orange RO',
  '226-03': 'Telekom RO',
};

/** Human operator name for a PLMN code, or the code itself when unknown. */
export function operatorName(plmn: string | undefined | null): string | undefined {
  if (!plmn) return undefined;
  const key = plmn.trim();
  return OPERATORS[key] ?? key;
}

/** Short radio-access label for a RAT badge: LTE stays LTE, GSM is shown as 2G. */
export function ratLabel(rat: string | undefined | null): string | undefined {
  if (!rat || rat === 'NONE') return undefined;
  if (rat === 'GSM') return '2G';
  return rat;
}

/** "cell_id · B3" (LTE) or "cell_id" when the band is unknown. */
export function cellLabel(
  cellId: string | number | undefined | null,
  band: string | number | undefined | null,
) {
  if (cellId === undefined || cellId === null || cellId === '') return undefined;
  if (band === undefined || band === null || band === '') return String(cellId);
  const b = String(band);
  return `${cellId} · ${/^\d+$/.test(b) ? `B${b}` : b}`;
}
